<template>
  <div>
    <div class="page-wrapper-table">
      <div class="page-wrapper-table-header">
        <el-select
          class="select-primary pagination-select"
          v-model="pagination.perPage"
          :placeholder="$t('COMMON.PER_PAGE')"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <base-input
          v-model="query"
          type="search"
          prepend-icon="fas fa-search"
          :placeholder="$t('COMMON.SEARCH')"
          clearable
        />
      </div>
      <div class="page-wrapper-table-body">
        <div class="page-wrapper-table-body-inner with-icones">
          <el-table
            class="align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="contractFiles"
            @sort-change="sortChange"
          >
            <div class="table-loading" slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <el-table-column label="" prop="file_type" min-width="50">
              <template v-slot="{ row }">
                <i v-if="row.file_type === 'pdf'" class="fas fa-file-pdf"></i>
                <i
                  v-else-if="row.file_type === 'word'"
                  class="fas fa-file-word"
                ></i>
                <i
                  v-else-if="row.file_type === 'excel'"
                  class="fas fa-file-excel"
                ></i>
                <i
                  v-else-if="row.file_type === 'image'"
                  class="fas fa-file-image"
                ></i>
                <i
                  v-else-if="row.file_type === 'text'"
                  class="fas fa-file-alt"
                ></i>
                <i v-else class="fas fa-file"></i>
                <!-- Par défaut -->
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('COMMON.NAME')"
              prop="name"
              sortable="custom"
              min-width="150"
            >
              <template v-slot="{ row }">
                <a :href="row.url ?? '#'" target="_blank">{{ row.name }}</a>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('CONTRACTS.SIGNATURE_TYPE')"
              prop="signature_type"
              min-width="150"
            >
              <template v-slot="{ row }">
                {{
                  row.signature_type
                    ? $t("CONTRACTS." + row.signature_type)
                    : ""
                }}
              </template>
            </el-table-column>
            <!-- 
            <el-table-column
              :label="$t('CONTRACTS.SIGNATURE_PAGES')"
              prop="tags"
              sortable="custom"
              min-width="150"
            >
              <template v-slot="{ row }">
                {{row.pages_to_sign}}
              </template>
            </el-table-column> -->

            <!-- <el-table-column :label="$t('COMMON.EXCERPT')" prop="excerpt">
              <template v-slot="{ row }">
                {{row.excerpt}}
              </template>
            </el-table-column> -->

            <el-table-column
              :label="$t('COMMON.CREATED_AT')"
              prop="created_at"
              sortable="custom"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ $timeZoneDateFormat(row.created_at) }}
              </template>
            </el-table-column>

            <el-table-column fixed="right" min-width="120">
              <div slot-scope="{ row }" class="table-actions">
                <el-tooltip
                  :content="$t('COMMON.VIEW')"
                  placement="top"
                  v-if="$currentUserCan($permissions.PERM_VIEW_CONTRACT_FILES)"
                >
                  <a
                    type="text"
                    @click="viewFile(row.id)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-expand-alt"></i>
                  </a>
                </el-tooltip>

                <el-tooltip
                  :content="$t('COMMON.EDIT')"
                  placement="top"
                  v-if="$currentUserCan($permissions.PERM_EDIT_CONTRACT_FILES)"
                >
                  <a
                    type="text"
                    @click="editFile(row.id)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-edit"></i>
                  </a>
                </el-tooltip>

                <el-tooltip
                  content="Delete"
                  placement="top"
                  v-if="
                    $currentUserCan($permissions.PERM_DELETE_CONTRACT_FILES)
                  "
                >
                  <a
                    type="text"
                    @click="deleteFile(row.id)"
                    class="table-action table-action-delete"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-trash-alt"></i>
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="page-wrapper-table-footer">
        <p class="card-category">
          {{
            $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
              from: total ? from + 1 : 0,
              to: to,
              of: total,
            })
          }}
          <span v-if="selectedRows.length">
            &nbsp; &nbsp;
            {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
          </span>
        </p>
        <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import "sweetalert2/dist/sweetalert2.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import models from "@/constants/models";

export default {
  name: "file-list-table",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  props: {
    contract: {
      type: Object,
      default: null,
      description: "Files linked contract",
    },
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      contractFiles: [],
      loading: true,
      selectedOrganization: null,
      selectedLocations: null,
      selectedObjectType: null,
      selectedTags: [],
      models: models,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    contact: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
            ...(this.contract.id ? { contract_id: this.contract.id } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
        await this.$store.dispatch("contractFiles/list", params);
        this.contractFiles = this.$store.getters["contractFiles/list"];
        this.total = this.$store.getters["contractFiles/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async deleteFile(id) {
      this.$emit("onDeleteFile", id);
    },

    async viewFile(id) {
      this.$emit("onViewFile", id);
    },

    async editFile(id) {
      this.$emit("onEditFile", id);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
